import { Box, Card, Divider, FormGroup, Grid, Stack, Typography, Badge } from '@mui/material';
import { makeStyles } from "@mui/styles";

import { ExpandLess, ExpandMore, RecentActors } from '@mui/icons-material';
import React, { useContext, useEffect, useState } from 'react'
import { useWatch } from 'react-hook-form';
import useSWRImmutable from 'swr/immutable';
import { retrieveNazioni } from '../../../api/tnazioni';
import BSSPreventivoContext from '../../../contexts/BSSPreventivoContext';
import BSSStyleContext from '../../../contexts/BSSStyleContext';

import useBSSLogger from "../../../hooks/useBSSLogger";
import { width2Breakpoint } from '../../../lib/theming';
import __t from '../../../lib/traduzioni';
import { MittDestEnum } from '../../account/Rubrica';
import BSSAutocomplete from '../../form/BSSAutocomplete';
import BSSSwitch from '../../form/BSSSwitch';
import BSSText from '../../form/BSSText';
import DefaultLoadingComponent from '../../form/DefaultLoadingComponent';
import CercaComune from '../CercaComune';
import CercaNazione from '../CercaNazione';
import { labelLocalita } from './FrammentoRiepilogo';
import ContattiConsigliati from '../ContattiConsigliati';
import DefaultErrorComponent from '../../form/DefaultErrorComponent';

const {logger} = useBSSLogger()

const styles = makeStyles((theme) => {

    const desktop = theme.breakpoints.up("lg");
    const mobile = theme.breakpoints.down("md");

    const obj = {
        root: {
            display: 'flex',
        },
        content: {
            flex: '1',        
        },        
    }

    return obj;
})


const mittdest = {
    "mittente": {
        label: __t("mittente"),
        Icon: RecentActors,
        partenzaarrivo: 'partenza'
    },
    "destinatario": {
        label: __t("destinatario"),
        Icon: RecentActors,
        partenzaarrivo: 'arrivo'
    },
    "contatto": {
        label: __t("contatto"),
        //Icon: RecentActors,
        partenzaarrivo: __t("contatto"),
    }
}

const FrammentoMittDest = ({classes, methods}) => {

    const {datiPregressi, rubrica = null} = useContext(BSSPreventivoContext)

    const {mainContainerWidth, theme} = useContext(BSSStyleContext);
    const cw = width2Breakpoint(mainContainerWidth / 1.3, theme)

    const mittdestclasses = styles()

    const [menuConsigliati, setMenuConsigliati] = useState({ctx: null, anchor: null})

    let consigliati = {mittente: [], destinatario: []};

    if(Array.isArray(rubrica)){
        
        //estrapolo solo i contatti compatibili con i comuni di mittente e destinatario
        logger.debug("frammento mitt dest rubrica", rubrica, methods.getValues());
        const {cap_comune_partenza, comune_comune_partenza, comune_partenza, nazione_partenza, cap_comune_arrivo, comune_comune_arrivo,  comune_arrivo, nazione_arrivo} = methods.getValues();
        
        let capPartenza = null;
        let capArrivo = null;
        let comunePartenza = null;
        let comuneArrivo = null;

        if(comune_partenza){
            const {cap, comune} = comune_partenza;
            capPartenza = cap;
            comunePartenza = comune;

        } else {
            capPartenza = cap_comune_partenza;
            comunePartenza = comune_comune_partenza;
        }
        const {iso: nazionePartenza} = nazione_partenza;

        if(comune_arrivo){
            const {cap, comune} = comune_arrivo;
            capArrivo = cap;
            comuneArrivo = comune;
        } else {
            capArrivo = cap_comune_arrivo;
            comuneArrivo = comune_comune_arrivo;
        }
        const {iso: nazioneArrivo} = nazione_arrivo;

        const comp = {
            mittente: {cap: capPartenza, comune: comunePartenza, iso: nazionePartenza},
            destinatario: {cap: capArrivo, comune: comuneArrivo, iso: nazioneArrivo},
        };

        ["mittente", "destinatario"].forEach((k)=> {
            consigliati[k] = rubrica.filter(contatto => 
                contatto.comune.cap === comp[k].cap && 
                contatto.comune.comune === comp[k].comune &&
                contatto.comune.nazione.iso === comp[k].iso
            );
        })
            

    }

    

    return (
        < >
            <Grid item xs={12} container >
                {Object.keys(mittdest).filter(ctx => ctx !== 'contatto').map((ctx, indiceMittDest) => {

                    const {label, Icon} = mittdest[ctx];

                    // const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
                    //     control: methods.control,
                    //     name: `${ctx}.indirizzo.indirizzo`
                    // }); 

                    const {partenzaarrivo} = mittdest[ctx];

                    return (
                        <Grid item xs={12} md={6} className={classes.formGroupBox} key={indiceMittDest}>
                            <Card>
                                <Box px={2} pt={1} >
                                    <div className={mittdestclasses.root}>
                                        <div className={mittdestclasses.content}>
                                            <Typography variant="h6">
                                                {/* <Grid container style={{ display: "flex" }} justify="space-between">                                                     */}
                                                <Stack direction="row" justifyContent="space-between" alignItems="center" >
                                                    <Box>{label}</Box>
                                                    {
                                                        ((consigliati?.[ctx]?.length ?? 0) > 0) && (
                                                            <>
                                                                <Box sx={{cursor: "pointer"}} onClick={e => setMenuConsigliati({ctx, anchor: e.currentTarget})}>
                                                                    <Badge badgeContent={consigliati?.[ctx]?.length} color={"secondary"} >
                                                                        <Icon size="small" color="primary" />
                                                                    </Badge>
                                                                </Box>
                                                                <ContattiConsigliati {...{menuConsigliati, setMenuConsigliati, consigliati, ctx, methods}} />
                                                            </>
                                                        )
                                                    } 
                                                    
                                                </Stack>
                                                    
                                                {/* </Grid> */}
                                            </Typography>
                                                                                                                
                                        </div>

                                        
                                    </div>
                                </Box>
                                
                            
                                <Divider />

                                <Box p={2}>
                                    <Contatto {...{
                                        methods,
                                        ctx,
                                        datiPregressi,
                                        cw
                                    }} />
                                    
                                    
                                </Box>

                            </Card>
                            {/* <pre>{JSON.stringify(methods.getValues(), null, 2)}</pre> */}

                        </Grid>
                    )
                })}
            </Grid>

            
                

        </>
    )
}

const Contatto = ({ctx, methods, datiPregressi, cw, fuoriSpedizione = false, attivaDettaglioIndirizzo = true}) => {

    const {partenzaarrivo} = mittdest[ctx];

    const campiDettaglio = [
        `${ctx}.nomeCampanello`, 
        `${ctx}.km`, 
        `${ctx}.palazzina`, 
        `${ctx}.Scala`, 
        `${ctx}.interno`, 
        `${ctx}.ufficio_stanza`, 
        `${ctx}.orarioChiusuraUfficiDa`, 
        `${ctx}.orarioChiusuraUfficiA`, 
        `${ctx}.ritiroPressoPortineria`
    ]

    const nessunDettaglio = campiDettaglio.reduce((esito, campo) => {
        return esito && [null, undefined].includes(methods.getValues(campo))
    }, true)

    const [mostraDettaglioIndirizzo, setMostraDettaglioIndirizzo] = useState(attivaDettaglioIndirizzo && !nessunDettaglio)

    return (
        <>
            <Grid container direction="row">
                {fuoriSpedizione ? (
                    <>
                        <Grid item width={1/3} 
                            mb={"1.2em"}>
                                        
                            <BSSAutocomplete
                                name={`${ctx}.proponiper`}
                                label={`${__t("proponiper")}`}
                                methods={methods}
                                dataProvider={async () => {                
                                    return Object.values(MittDestEnum);
                                }}            
                                ControllerProps={{rules: {required: __t("validazione.requiredField", [`${__t("proponiper")}`])}}}
                                AutocompleteProps={{
                                    getOptionLabel: (option) => option.text,
                                    renderOption: (props, option, { selected }) =>(
                                        <li {...props}>
                                            <div>{option.text}</div>                                    
                                        </li>
                                    )                
                                }}
                            />
                        </Grid>    
                    </>
                ) : ""}


                <Grid item width={fuoriSpedizione ? 2/3 : 1} 
                    mb={"1.2em"}>
                    
                    <BSSText
                        name={`${ctx}.ragionesociale`} 
                        label={__t("ragionesociale")}    
                        methods={methods}                                                                                              
                        // TextFieldInputProps={{
                        //     endAdornment: (
                        //         <InputAdornment position="end">
                        //             <IconButton size="small" color="primary">
                        //                 <Contacts />
                        //             </IconButton>
                                    
                        //         </InputAdornment>
                        //     )
                        // }}     
                        ControllerProps={{
                            rules: {
                                required: __t("validazione.requiredField", [__t("ragionesociale")])
                            }
                        }}                                                                            
                    />
                </Grid>                                                                                        
            </Grid>

            <Grid container direction="row">
                <Grid item width={{xs: 1, sm: 1, md: 1/3, lg: 1/4}["md"]} 
                    mb={"1.2em"}>
                    
                    <BSSText
                        name={`${ctx}.prefisso`} 
                        label={__t("prefisso")}    
                        methods={methods}   
                        ControllerProps={{
                            rules: {
                                required: __t("validazione.requiredField", [__t("prefisso")])
                            }
                        }}                                          
                    />

                    
                </Grid>    
                <Grid item width={{xs: 1, sm: 1, md: 2/3, lg: 3/4}["md"]} 
                    mb={"1.2em"}>
                    
                    <BSSText
                        name={`${ctx}.numero`} 
                        label={__t("numero")}    
                        methods={methods}              
                        ControllerProps={{
                            rules: {
                                required: __t("validazione.requiredField", [__t("numero")])
                            }
                        }}                               
                    />

                    
                </Grid>                                                                                    
            </Grid>

            <Grid container direction="row">
                <Grid item width={1} 
                    mb={"1.2em"}>
                    
                    <BSSText
                        name={`${ctx}.contattare`} 
                        label={__t("contattare")}    
                        methods={methods}        
                        ControllerProps={{
                            rules: {
                                required: __t("validazione.requiredField", [__t("contattare")])
                            }
                        }}                                                                                                                                                                                                                   
                    />
                </Grid>          
                <Grid item width={1} 
                    mb={"1.2em"}>
                    
                    <BSSText
                        name={`${ctx}.email`} 
                        label={__t("email")}    
                        methods={methods}        
                        ControllerProps={{
                            rules: {
                                required: __t("validazione.requiredField", [__t("email")])
                            }
                        }}                                                                                                                                                                                                                   
                    />
                </Grid>                                                                                        
            </Grid>
            
            <Grid container direction="row">
                
                <Grid item width={{xs: 1, sm: 1, md: 2/3, lg: 3/4}["md"]} 
                    mb={"1.2em"}>
                    
                    <BSSText
                        name={`${ctx}.indirizzo`} 
                        label={__t("indirizzo")}    
                        methods={methods}    
                        ControllerProps={{
                            rules: {
                                required: __t("validazione.requiredField", [__t("indirizzo")])
                            }
                        }}                                                                                         
                    />

                    
                </Grid>  

                <Grid item width={{xs: 1, sm: 1, md: 1/3, lg: 1/4}["md"]} 
                    mb={"1.2em"}>
                    
                    <BSSText
                        name={`${ctx}.civico`} 
                        label={__t("civico")}    
                        methods={methods}    
                        ControllerProps={{
                            rules: {
                                required: __t("validazione.requiredField", [__t("civico")])
                            }
                        }}                                         
                    />

                    
                </Grid>    
            </Grid>

            {ctx !== 'contatto' ? (
                <>
                    <Grid container direction="row">
                        <Grid item width={{xs: 1, sm: 1, md: 1/3, lg: 1/4}[cw]} 
                            mb={"1.2em"}>
                            
                            <BSSText
                                name={`${ctx}.comune.provincia.iso`} 
                                label={__t("isoprovincia")}    
                                methods={methods}   
                                TextFieldProps={{inputProps: {maxLength: 2}}}   
                                TextFieldInputProps={{
                                    disabled: ![null, undefined].includes(methods.getValues(`comune_${partenzaarrivo}.provincia.id`)),
                                }}   
                                ControllerProps={{
                                    defaultValue: methods.getValues(`comune_${partenzaarrivo}.provincia.iso`),
                                    rules: {
                                        required: __t("validazione.requiredField", [__t("isoprovincia")])
                                    }
                                }}                                     
                            />

                            
                        </Grid>    
                        <Grid item width={{xs: 1, sm: 1, md: 2/3, lg: 3/4}[cw]} 
                            mb={"1.2em"}>
                            
                            <BSSText
                                name={`${ctx}.comune.label`} 
                                label={__t("comune")}    
                                methods={methods}                   
                                TextFieldInputProps={{
                                    disabled: true,
                                }}     
                                ControllerProps={{
                                    defaultValue: labelLocalita(partenzaarrivo, datiPregressi),
                                    rules: {
                                        required: __t("validazione.requiredField", [__t("comune")])
                                    }
                                }}                     
                            />

                            
                        </Grid>                                                                                    
                    </Grid>
                </>
            ) : (
                <>
                    <LocalitaContatto {...{name: ctx, methods, cw}} />
                </>
            )}                                        

            {attivaDettaglioIndirizzo && (
                <>
                    <fieldset>
                        <legend style={{cursor: 'pointer'}} onClick={e => setMostraDettaglioIndirizzo(!mostraDettaglioIndirizzo)}>
                                <Box style={{width: "100%", display: 'flex'}}>

                                    <Box flexGrow={1}>
                                        {__t("dettaglioindirizzo")} ({mostraDettaglioIndirizzo ? __t("nascondi") : __t("mostra")})
                                    </Box>

                                    <Box pt={0.5}>
                                        {mostraDettaglioIndirizzo ? 
                                            (<ExpandLess />) 
                                            : (<ExpandMore />)
                                        }
                                    </Box>
                                    

                                </Box>
                            
                        </legend>
                    
                        {mostraDettaglioIndirizzo && (
                            <Box pb={2}>
                                <FormGroup row>
                                    <Box width={1} 
                                        mb={"1.2em"}>
                                        
                                        <BSSText
                                            name={`${ctx}.nomeCampanello`} 
                                            label={__t("nomeCampanello")}    
                                            methods={methods}                                                                                                                                                                                                                                                
                                        />
                                    </Box>                                                                                        
                                </FormGroup>

                                <FormGroup row>
                                    <Box width={1} 
                                        mb={"1.2em"}>
                                        
                                        <BSSText
                                            name={`${ctx}.km`} 
                                            label={__t("km")}    
                                            methods={methods}                                
                                        />
                                    </Box>                                                                                        
                                </FormGroup>

                                <FormGroup row>
                                    <Box width={1} 
                                        mb={"1.2em"}>
                                        
                                        <BSSText
                                            name={`${ctx}.palazzina`} 
                                            label={__t("palazzina")}    
                                            methods={methods}                                                                                                                                                                                                                                          
                                        />
                                    </Box>                                                                                        
                                </FormGroup>

                                <FormGroup row>
                                    <Box width={1} 
                                        mb={"1.2em"}>
                                        
                                        <BSSText
                                            name={`${ctx}.Scala`} 
                                            label={__t("scala")}    
                                            methods={methods}                                                                                                                                                                                                                                                
                                        />
                                    </Box>                                                                                        
                                </FormGroup>

                                <FormGroup row>
                                    <Box width={1} 
                                        mb={"1.2em"}>
                                        
                                        <BSSText
                                            name={`${ctx}.interno`} 
                                            label={__t("interno")}    
                                            methods={methods}                                
                                        />
                                    </Box>                                                                                        
                                </FormGroup>

                                <FormGroup row>
                                    <Box width={1} 
                                        mb={"1.2em"}>
                                        
                                        <BSSText
                                            name={`${ctx}.ufficio_stanza`} 
                                            label={__t("ufficio_stanza")}    
                                            methods={methods}                                                                                                                                                                                                                                          
                                        />
                                    </Box>                                                                                        
                                </FormGroup>
                                <Grid container direction="row">
                                    <Grid item width={1/2} 
                                        mb={"1.2em"}>
                                        
                                        <BSSText
                                            name={`${ctx}.orarioChiusuraUfficiDa`} 
                                            label={__t("orarioChiusuraUfficiDa")}    
                                            methods={methods}                                                                                                                                                                                                                                          
                                        />
                                    </Grid>  
                                    <Grid item width={1/2} 
                                        mb={"1.2em"}>
                                        
                                        <BSSText
                                            name={`${ctx}.orarioChiusuraUfficiA`} 
                                            label={__t("orarioChiusuraUfficiA")}    
                                            methods={methods}                                                                                                                                                                                                                                          
                                        />
                                    </Grid>                                                                                        
                                </Grid>
                                <FormGroup row>
                                    <Box width={1} 
                                        mb={"1.2em"}>
                                        
                                        <BSSSwitch
                                            name={`${ctx}.ritiroPressoPortineria`} 
                                            label={__t("ritiroPressoPortineria")}    
                                            methods={methods}                                                                                                                                                                                                                                          
                                        />
                                    </Box>                                                                                        
                                </FormGroup>                                
                            </Box>
                        )}
                        
                    </fieldset>
                </>
            )}
            
            <FormGroup row>
                <Box width={1} 
                    pt={2}
                    mb={"1.2em"}>
                    
                    <BSSText
                        name={`${ctx}.note`} 
                        label={__t("note")}    
                        methods={methods}    
                        TextFieldProps={{
                            multiline: true,
                            rows: 3
                        }}                                                                                                                                                                                                                       
                    />
                </Box>                                                                                        
            </FormGroup>

            <Grid container style={{ display: "flex" }} justify="space-between">  

                    <FormGroup row>
                        <Box width={1} 
                            mb={"1.2em"}>
                            
                            <BSSSwitch 
                                name={`${ctx}.def`} 
                                label={__t("contattodefault", [__t(ctx)])}    
                                methods={methods}  
                                SwitchProps={{
                                    afterChange: v => methods.setValue(`${ctx}.contattodef`, v)
                                }}
                            />
                            <span style={{display: "none"}}>
                                <BSSSwitch 
                                    name={`${ctx}.contattodef`} 
                                    label={__t("contattodefault", [__t(ctx)])}    
                                    methods={methods}    
                                />
                            </span>
                        </Box>                                                                                        
                    </FormGroup>
                </Grid>
        </>
    )
}

const LocalitaContatto = ({name, methods, cw}) => {

    const datiDefault = async () => {
        const nazioni = await retrieveNazioni();

        return {
            nazioni
        }
    }

    const comuneobj = useWatch({name: `comune_${name}`});
    const isoprov = comuneobj?.provincia?.iso ?? null;
    const currprov = methods.getValues(`provincia_${name}`)


    useEffect(()=> {
        if( currprov !== isoprov ){
            methods.setValue(`provincia_${name}`, isoprov !== null ? isoprov : "")
        } 
    }, [currprov, isoprov])

    

    const {data, error} = useSWRImmutable("api/datiLocalitaContatto", datiDefault);


    if(error){
        return <DefaultErrorComponent {...{error}} />
    }

    if(!data && !error){
        return <DefaultLoadingComponent />
    }

    return (
        <>
            <Grid container direction="row">
                <Grid item width={{xs: 1, sm: 1, md: 1/5, lg: 1/7}[cw]} 
                    mb={{xs: "0.5em", sm: "0.5em", md: "0.5em"}[cw]}>
                        <CercaNazione name={`nazione_${name}`} nazioni={data.nazioni} methods={methods} />
                </Grid>
                <Grid item width={{xs: 1, sm: 1, md: 3/5, lg: 5/7}[cw]} 
                    mb={{xs: "0.5em", sm: "0.5em", md: "0.5em"}[cw]} >
                        <CercaComune name={`comune_${name}`} dependsOn={[`nazione_${name}`]}  methods={methods} />
                </Grid>
                <Grid item width={{xs: 1, sm: 1, md: 1/5, lg: 1/7}[cw]} 
                    mb={{xs: "0.5em", sm: "0.5em", md: "0.5em"}[cw]} >                        
                    <BSSText 
                        name={`provincia_${name}`} 
                        label={__t('isoprovincia')} 
                        dependsOn={[`comune_${name}`]}  
                        methods={methods} 
                        TextFieldProps={{inputProps: {maxLength: 2, readOnly: isoprov !== null}}}       
                        ControllerProps={{
                            rules: {
                                required: __t("validazione.requiredField", [__t("prefisso")])
                            }
                        }}                  
                    />
                </Grid>
            </Grid>
            
        </>
    )
}

export default FrammentoMittDest;

export {Contatto, LocalitaContatto, styles}